import { render, staticRenderFns } from "./DarkToggler.vue?vue&type=template&id=2116df90&"
import script from "./DarkToggler.vue?vue&type=script&lang=js&"
export * from "./DarkToggler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2116df90')) {
      api.createRecord('2116df90', component.options)
    } else {
      api.reload('2116df90', component.options)
    }
    module.hot.accept("./DarkToggler.vue?vue&type=template&id=2116df90&", function () {
      api.rerender('2116df90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/layouts/components/app-navbar/components/DarkToggler.vue"
export default component.exports